<template>
 <Head>
    <title> Staff Skills | {{staff.first_name}} {{staff.surname}} | {{$page.props.appName}}</title>
    <meta name="description" :content="'View staff skills' + $page.props.appName">
  </Head>
    <div class="w-full flex">
        <div
            class="
                bg-black
                border-t border-white
                flex flex-row
                items-center
                text-white
                w-full
            "
        >
            <svg
                class="w-24 h-24 inline"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
                <path
                    d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
                ></path>
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                ></path>
            </svg>

            <h1 class="text-3xl font-semibold inline ml-2">
                Skills & Competency Record
            </h1>
        </div>

        <div></div>
    </div>

    <div class="p-3">
        <div class="p-3 rounded shadow mt-3 bg-gray-100 flex items-center justify-between">
            <div class="flex flex-wrap items-center justify-center">
                <img
                class="user-avatar inline"
                :src="'/avatar/' + staff.image"
                alt=""
            />
            <p class="text-2xl font-bold inline ml-3">
                {{ staff.first_name }} {{ staff.surname }}
            </p>
            </div>

            <div class="float-right text-center">
                
                <Link :href="'/admin/personal-details/' + this.staff.id"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                <p class="font-semibold">Edit personal details</p>
                </Link>
            </div>
        </div>

        <div class="mt-3 flex flex-wrap items-center justify-center">
            <div
                class="
                    xl:w-1/4 lg:w-1/4 md:1/2 sm:w-full w-full
                    border-2 border-black border-radius
                    shadow-sm
                    text-center
                    mx-3 my-1
                    p-2

                "
            >
                <h2 class="font-semibold">Competence Status </h2>
                <pi-chart :part="total"  :width="300" :height="300"></pi-chart>
            </div>
            <div
                class="
                    xl:w-1/4 lg:w-1/4 md:1/2 sm:w-full w-full
                    border-2 border-black border-radius
                    shadow-sm
                    text-center
                    mx-3 my-1
                    p-2
                "
            >
                <h2 class="font-semibold">Expired Levels</h2>
                <p>Expired Levels</p>
                <div
                    class="
                        bg-red-500
                        text-white
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                    "
                >
                    <p class="text-3xl">{{expired}}</p>
                </div>

                <p>Pending Expires</p>
                <div
                    class="
                        bg-yellow-500
                        text-white
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                    "
                >
                    <p class="text-3xl">{{pending}}</p>
                </div>
            </div>
            <div
                class="
                    xl:w-1/4 lg:w-1/4 md:1/2 sm:w-full w-full
                    border-2 border-black border-radius
                    shadow-sm
                    text-center
                    mx-3 my-1
                    p-2

                "
            >
                <h2 class="font-semibold">Average</h2>
                <p>Average Target Level</p>
                <div
                    class="
                        bg-red-500
                        text-white
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                    "
                >
                    <p class="text-3xl">100%</p>
                </div>

                <p>Competency Completion</p>
                <div
                    class="
                        border-2 border-black
                        text-black
                        rounded-3xl
                        h-12
                        m-3
                        flex
                        items-center
                        justify-center
                        bg-indigo-400
                    "
                >
                    <p class="text-3xl">{{100 - total}}%</p>
                </div>
            </div>
        </div>

        <div class="mt-3 mx-3">
            <h1 class="font-bold text-3xl border-b-2 border-black">Skills</h1>
            <button class="bg-black text-white font-bold rounded p-3 mx-3 my-2" @click="addSkill == true ? addSkill = false : addSkill = true">
                Add skill
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                    />
                </svg>
            </button>
                        <div class="p-8 ml-3 flex flex-wrap bg-gray-100 xl:w-1/2 lg:w-1/2 md:w-1/2"  v-if="addSkill">
                            <form action=" " class="flex flex-wrap">

                                    <div class="pr-6 pb-8 w-full lg:w-1/3">
                                    <label for="text-input-17" class="form-label">Skill selection:</label>
                                    <select name="" class="form-select" id=""  v-model="this.form.skill_id">
                                        <option :value="skill.id" :key="skill.id" v-for="skill in skills">
                                            {{skill.skill_name}}
                                        </option>
                                    </select>
                                </div>
                            <div class="pr-6 pb-8 w-full lg:w-1/3">
                                <label for="text-input-17" class="form-label">Achieved Date:</label>
                                <input type="date" class="form-input" v-model="this.form.achieved_date">
                            </div>

                            <div class="pr-6 pb-8 w-full lg:w-1/3">
                                <label for="text-input-17" class="form-label">Expiry Date:</label>
                                <input type="date" class="form-input"  v-model="this.form.expiry_date">
                            </div>


                             </form>
                            
                                <div class="pr-6 pb-8 w-full lg:w-1/2">
                                <label for="text-input-17" class="form-label">Front of card:</label>
                                <button class="bg-black text-white font-bold uppercase p-3 rounded mt-3"  @click="$refs.front_card.click()">UPLOAD FRONT OF CARD</button>
                                <input type="file" class="hidden" ref="front_card" @change="frontChange($event)" accept="image/*" />

                                 <img
                                :src="front_card"
                                v-if="front_card.length > 0"
                                width="300"
                                height="300"
                                class="mt-2 px-8"
                                />

                               

                            </div>
                            <div class="pr-6 pb-8 w-full lg:w-1/2">


                             <label for="text-input-17" class="form-label">Back of card:</label>
                                <button class="bg-black text-white font-bold uppercase p-3 rounded mt-3" @click="$refs.back_card.click()">UPLOAD BACK OF CARD</button>
                                <input type="file" class="hidden" ref="back_card" @change="backChange($event)" accept="image/*" />

                                 <img
                                :src="back_card"
                                v-if="back_card.length > 0"
                                width="300"
                                height="300"
                                class="mt-2 px-8"
                                />
                            </div>
                            <button class="float-right bg-black text-white font-bold font-sm rounded p-3 mx-3 my-2" @click="submit()" :disabled="form.processing">ADD SKILL</button>

                        </div>

                        <p v-if="selfskills.length==0" class="font-semibold text-2xl text-center">
                            No skills to show!
                        </p>

                        <div v-else>
                            <div v-for="(skillgroup,key) in selfskills" :key="key" class="mt-2 rounded-md  overflow-x-auto">
                                <h2 class="font-bold text-2xl border-b-2 border-black mb-2"> {{key}}</h2>
                                 <table class="p-3 w-full shadow">
                                     <thead class="bg-gray-100 text-left">
                                         <th class="p-1"></th>
                                         <th class="p-1 text-center">Target Definition</th>
                                         <th class="p-1 text-center">Actual Definition</th>
                                         <th class="p-1 text-center">Date Attained</th>
                                         <th class="p-1 text-center">Expiry Date</th>
                                         <th class="p-1 text-center"></th>
                                         <th class="p-1 text-center"></th>

                                     </thead>
                                     <skill-row v-for="skill in skillgroup" :key="skill.id" :skill="skill"> </skill-row>
                                 </table>
                
                            </div>
                        </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import PiChart from "@/Shared/PiChart"
import SkillRow from "./SkillRow.vue";
import moment from 'moment'
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
      data() {
    return {
      addSkill : false,
      front_card: '',
      back_card : '',
      form: this.$inertia.form({
         skill_id : null,
         achieved_date : null,
         expiry_date : null,
         front_card : null,
         back_card : null
      }),
    };
  },
    layout: Layout,
    props: {
        staff: Object,
        skills : Object,
        selfskills : Object,
        expired : Number,
        pending : Number,
        total : Number
    },
    components: { PiChart, SkillRow, Link,Head },
    methods : {
        submit(){
            this.form.post("/admin/skill/" + this.staff.id + "/create");
            this.form.skill_id = null;
            this.form.achieved_date = null;
            this.form.expiry_date = null;
            this.front_card = '';
            this.back_card = '';
            this.form.front_card = null;
            this.form.back_card = null;
        },
        frontChange(e){
            e.preventDefault();
            const file = e.target.files[0];
            this.form.front_card = file;
            this.front_card = URL.createObjectURL(file);
        },
         backChange(e){
            e.preventDefault();
            const file = e.target.files[0];
            this.form.back_card = file;
            this.back_card = URL.createObjectURL(file);
        }
        
    }
};
</script>
